import { Crumb } from './types';
import { TEXT } from './strings';

interface Props {
  breadcrumbs?: Crumb[];
  overflow?: boolean;
}

const Breadcrumbs = ({ breadcrumbs = [], overflow = false }: Props) => {
  const RaulCrumb = ({ key, title, url }: Crumb, back = false) => (
    <raul-breadcrumb
      // @ts-expect-error: children "does not exist on type"
      // eslint-disable-next-line react/no-children-prop
      children={
        <a href={url}>
          {back ? (
            <>
              <raul-breadcrumb-back-icon /> {TEXT.BACK}
            </>
          ) : (
            title
          )}
        </a>
      }
      key={key}
    />
  );

  return (
    <raul-breadcrumbs
      // @ts-expect-error: children "does not exist on type"
      // eslint-disable-next-line react/no-children-prop
      children={
        breadcrumbs?.length >= 2 ? (
          <>
            <div className="r-hidden md:r-block">
              {breadcrumbs.map((crumb) => RaulCrumb(crumb))}
            </div>
            <div className="sm:r-hidden">
              {RaulCrumb(breadcrumbs[breadcrumbs.length - 2], true)}
            </div>
          </>
        ) : (
          <raul-eyebrow />
        )
      }
      overflow={overflow}
    />
  );
};

export default Breadcrumbs;
